export default {
  custom_option: 'Personalizat',
  zero_option: 'Fără bacșiș',
};
